import { Injectable, inject } from '@angular/core';
import { User } from '@app/model/user';
import { Notification } from '@app/model/notification';
import { SupabaseClient } from '@supabase/supabase-js';
import { UserService } from '../user-service/user.service';
import { IdentityApply } from '@app/model/identity-apply';
import { SUPABASE_CLIENT } from '@app/providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class IdentityApplyService {
  user: User = new User('', '', '', '', '', '', '', 0, 0, 0, '', false, false, false, 0, '', '', '');
  notification: Notification = new Notification('', '', '', '', '', false, '', '');
  userId: any;
  allUserId: any[] = [];

  private supabaseClient: SupabaseClient;

  constructor(private userService: UserService) {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  async getIdentityApplyById(id: string) {
    const res = await this.supabaseClient.from('identity_apply').select('*').eq('id', id);
    return res?.data;
  }

  async getAllIdentityApply() {
    const res = await this.supabaseClient.from('identity_apply').select('*');
    if (res.error) throw res.error;
    return res?.data;
  }

  async createIdentityApply(data: IdentityApply) {
    const userId = await this.userService.getUserId();
    const res = await this.supabaseClient
      .from('identity_apply')
      .insert([
        {
          created_at: new Date(),
          create_from: userId,
          identity_document_url: data.identity_document_url
        }
      ]);
    if (res.error) throw res.error;
    return res;
  }

  async deleteIdentityApply(id: string) {
    const res = await this.supabaseClient.from('identity_apply').delete().eq('id', id);
    if (res.error) throw res.error;
    return res;
  }
}
